import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=2354155b&scoped=true&"
import script from "./verification.vue?vue&type=script&lang=js&"
export * from "./verification.vue?vue&type=script&lang=js&"
import style0 from "./verification.vue?vue&type=style&index=0&id=2354155b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354155b",
  null
  
)

export default component.exports